window.Swal = require('sweetalert2');
window.axios = require('axios');

window.Tawk_API = window.Tawk_API || {};
window.Tawk_LoadStart = new Date();
window.Tawk_API.onLoad = function() {
    console.log('load')
    var statusDiv_id = 'status-tawkto';
    var pageStatus = window.Tawk_API.getStatus();

    if (pageStatus === 'online') {
        document.getElementById(statusDiv_id).innerHTML = 'El Chat en Vivo está <span class="badge badge-success">En Linea</span>';
    } else if (pageStatus === 'away') {
        document.getElementById(statusDiv_id).innerHTML = 'El Chat en Vivo está <span class="badge badge-warning">Ocupado</span>';
    }
};
window.Tawk_API.onStatusChange = function(status) {
    console.log('status-change', { status })
    var statusDiv_id = 'status-tawkto';
    if (status === 'online') {
        document.getElementById(statusDiv_id).innerHTML = 'El Chat en Vivo está <span class="badge badge-success">En Linea</span>';
    } else if (status === 'away') {
        document.getElementById(statusDiv_id).innerHTML = 'El Chat en Vivo está <span class="badge badge-warning">Ocupado</span>';
    }
};
window.Tawk_API.onOfflineSubmit = function(data) {
    const url = '/api/contacto/offline-submit';

    window.axios.post(url, data)
        .then(console.log)
        .catch(console.error);
};
window.Tawk_API.onPrechatSubmit = function(data) {
    console.log("PRECHAT", data);
}

